import React from 'react';
import { SimilarAuthorsCarousel } from '@novelist/novum-novella-ui';
import AnalyticsWrapperContainer from './AnalyticsWrapperContainer';
import * as SimilarAuthorsSelector from '../../data/SimilarAuthorsSelectors';

const SimilarAuthorsCarouselContainer = () => {
	let authorsCardModel = SimilarAuthorsSelector.getSimilarAuthors();

	let recommendedAuthors =  authorsCardModel.map((item) => ({
		ui: item.uniqueId,
		recommendedReason: item.reason,
		author: item.authorName,
		catalogLinkUrl: item.catalogLink
	}));
	
	if(recommendedAuthors.length){
		return (
			<AnalyticsWrapperContainer
			Component={<SimilarAuthorsCarousel recommendedAuthors={recommendedAuthors} />}
			componentName={'Similar Author'}
			featureType={'Author Read-alikes'}
		/>);
	}
	else{
		return null;
	}
}

export default SimilarAuthorsCarouselContainer; 


// WEBPACK FOOTER //
// ./src/react/containers/SimilarAuthorsCarouselContainer.jsx